import { SelectMenu, SelectMenuTypes } from '@dtsl/react';
import useLanguage from '../../state/useLanguage/useLanguage';

interface LanguageOption {
  key: string;
  value: string;
  label: string;
}

const languages: LanguageOption[] = [
  { key: 'en', value: 'en', label: 'EN' },
  { key: 'de', value: 'de', label: 'DE' },
  { key: 'es', value: 'es', label: 'ES' },
  { key: 'fr', value: 'fr', label: 'FR' },
  { key: 'it', value: 'it', label: 'IT' },
  { key: 'pt', value: 'pt', label: 'PT' },
];

export default function LanguageSelector() {
  const { lang, changeLanguage } = useLanguage();

  const currentLanguage = languages.find((l) => l.value === lang) || languages[0];

  const handleSelect = (option: LanguageOption) => {
    changeLanguage(option.value);
  };

  return (
    <SelectMenu
      identifier="language-selector"
      selectMenuType={SelectMenuTypes.SINGLE_SELECTION}
      options={languages}
      onSelect={handleSelect}
      value={[currentLanguage]}
      size="small"
    />
  );
}
